export const SENDER_EMAIL = "donotreply@centiro.cloud";
export const NOTIFICATION_SUBJECT = "Return order creation email";